import BaseState from '@state/BaseState'
import { Signals} from "@/Imports";
import GameStatesEnum from "@/states/GameStatesEnum";

export default class SpinStopState extends BaseState {

  begin() {
    Signals.stopSpin.dispatch(this.model.gridStages)
    Signals.reelsStopComplete.add(this.end, this)
  }

  end = () => {
    let gameState = GameStatesEnum.FINAL
    this.stateMachine.setState(gameState)
  }

  cleanUp() {
    Signals.reelsStopComplete.remove(this.end, this)
  }
}
